import React from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';

function ExternalScreenMove(props) {

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onConfirmation(true);
    }
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogContent>
        {TR.cm_open_video_to_ext_screen_question}
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={() => props.onConfirmation(false)}>{TR.cm_no}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onConfirmation(true)}>{TR.cm_yes}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default ExternalScreenMove;